import { environment } from 'src/environments/environment';
const baseUrl = environment.baseUrl;
const configUrl = environment.configUrl;
const admin = baseUrl + '/admin';
const websiteUrl = environment.websiteUrl;

export const ApiUrls = {
    open: admin + '/open',
    schWebmaintance1: websiteUrl + '/schWebmaintance',
    visitor: baseUrl + '/visitor',
    downloadFileUrl: baseUrl + '/file/download?' + 'fileUuid=',
    downloadFileUrl1: websiteUrl + '/file/download?' + 'fileUuid=',
    downloadFileUrl2: websiteUrl + '/file/download/v3?' + 'fileUuid=',
    // path on the school's own domain; nginx forwards it to .../file/download/v3
    publicDisclosureFilePath: '/publicDisclosure?fileUuid=',

    getNewsByStatus: websiteUrl + '/news/by/status',
    getWebNewsList: websiteUrl + '/news/list',
    getWebFaqByStatus: websiteUrl + '/faq/by/status',
};
